import { ChoiceGroup } from "@/components/forms/ChoiceGroup";

type Props = {
  id: string;
  label: string;
  options: string[];
  value: unknown;
  onChange: (v: string) => void;
  error?: string;
};

export function FieldRadio({ id, label, options, value, onChange, error }: Props) {
  const v = typeof value === "string" ? value : "";
  return (
    <ChoiceGroup
      id={id}
      legend={label}
      options={options.map((opt) => ({ value: opt, label: opt }))}
      value={v || null}
      onChange={(next) => {
        if (next != null) onChange(next);
      }}
      error={error}
    />
  );
}
